import { useContent } from "@/context/ContentContext";

const DEFAULT_VRAGEN = [
  {
    vraag: "Welke houtsoorten gebruikt De Houtregisseur?",
    antwoord:
      "We werken met massieve houtsoorten zoals Europees eiken, Amerikaans noten, essenhout, beuken en hoogwaardig multiplex, afgestemd op de functie en jouw esthetische voorkeur.",
  },
  {
    vraag: "Hoe lang duurt het maken van een maatwerk meubel?",
    antwoord:
      "De doorlooptijd is afhankelijk van de complexiteit en actuele planning in de werkplaats. Na de ontwerpfase geven we altijd een heldere richttijd af.",
  },
  {
    vraag: "Kan ik ook met een simpele schets of foto langskomen?",
    antwoord:
      "Zeker! Juist in de vroege fase denkt René graag mee om van een ruwe schets een realiseerbaar en functioneel meubelstuk te maken.",
  },
];

export const Faq = () => {
  const { content } = useContent();
  const vragen = content?.faq?.length
    ? DEFAULT_VRAGEN.map((v, i) => ({ ...v, ...(content.faq[i] || {}) }))
    : DEFAULT_VRAGEN;

  return (
    <section data-testid="faq-section" className="py-20 bg-[#FBF9F5] px-6 border-t border-[#EAE3DA]">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 hr-reveal">
          <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">
            Veelgestelde Vragen
          </span>
          <h2 className="text-3xl font-normal font-display text-[#2B231D] mt-2">
            Praktische informatie over maatwerk
          </h2>
        </div>

        <div className="space-y-6">
          {vragen.map((v, i) => (
            <div
              key={i}
              data-testid={`faq-item-${i}`}
              className="p-6 rounded-2xl bg-white border border-[#EAE3DA] hr-reveal"
            >
              <h3 className="text-base font-bold text-[#2B231D] mb-2">{v.vraag}</h3>
              <p className="text-sm text-[#6C5E52] leading-relaxed">{v.antwoord}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
